const scope = {
    name_exists: 'O nome do escopo {{name}} já está em uso',
    name_with_space: 'O nome do escopo não pode conter espaços.',
};
export default scope;
